/**
 * @generated SignedSource<<fb32eb7f3f8a03ab36ea02fb01870214>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZnglyPostTypeEnum = "Catalog" | "Category" | "CrmList" | "Form" | "FormEntry" | "Hub" | "HubPage" | "MediaItem" | "SiteSettings" | "Znglist";
export type EmptyTrashInput = {
  clientMutationId?: string | null | undefined;
  postType: ZnglyPostTypeEnum;
};
export type BatchPostMutation_EmptyTrash_Mutation$variables = {
  input: EmptyTrashInput;
};
export type BatchPostMutation_EmptyTrash_Mutation$data = {
  readonly emptyTrash: {
    readonly ids: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly message: string | null | undefined;
  } | null | undefined;
};
export type BatchPostMutation_EmptyTrash_Mutation = {
  response: BatchPostMutation_EmptyTrash_Mutation$data;
  variables: BatchPostMutation_EmptyTrash_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmptyTrashPayload",
    "kind": "LinkedField",
    "name": "emptyTrash",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ids",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BatchPostMutation_EmptyTrash_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BatchPostMutation_EmptyTrash_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e576a5f9a00124e1c7f8e1223730b877",
    "id": null,
    "metadata": {},
    "name": "BatchPostMutation_EmptyTrash_Mutation",
    "operationKind": "mutation",
    "text": "mutation BatchPostMutation_EmptyTrash_Mutation(\n  $input: EmptyTrashInput!\n) {\n  emptyTrash(input: $input) {\n    ids\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a8e7064aec73fe109650789c3936221";

export default node;
